export const navLinks = [
    {
      id: "home",
      title: "HOME",
    },
    {
      id: "about",
      title: "ABOUT",
    },
    {
      id: "skills",
      title: "SKILLS",
    },
    {
      id: "project",
      title: "PROJECTS",
    },
    {
      id: "experience",
      title: "EXPERIENCE",
    },
    {
      id: "contact",
      title: "CONTACT",
    },
  ];